import Alpine from 'alpinejs';
import { getNarrativeManager } from './includes/narrative.js';
import { getArchiveManager } from './includes/archive.js';
import { videoPlayer } from './includes/video_player.js';

Alpine.data('video_player', videoPlayer);
Alpine.data('argonaut_archive', getArchiveManager);

if (ARGONAUT.narrative) {
	const state = history.state || {};
	if ('undefined' === typeof state.argonaut_exit_url) {

		const prev_history_length = localStorage.getItem('argonaut_hlength');
		let referrer = document.referrer;

		if (!referrer && window.history.length == prev_history_length) {
			referrer = localStorage.getItem('argonaut_pref') || '';
		}

		if (referrer && window.location.hostname !== new URL(referrer).hostname) {
			referrer = '';
		}

		state.argonaut_exit_url = referrer;

		window.history.replaceState(state, '');
		localStorage.setItem('argonaut_pref', referrer);
		localStorage.setItem('argonaut_hlength', window.history.length);
	}

	if (state.argonaut_exit_url) {
		ARGONAUT.narrative.exit_url = state.argonaut_exit_url;
	}

	Alpine.data('argonaut_slides', () => getNarrativeManager(ARGONAUT.narrative));
}

Alpine.start();